import clsx from 'clsx'
import {Dispatch, FC, SetStateAction} from 'react'
import '../../../shared/catalog-responsive/CatalogChoice.css'

type props = {
  type: {
    type: number | undefined
    setType: Dispatch<SetStateAction<number | undefined>>
  }
}

const buyerTypes = [
  {value: 1, label: 'حقیقی', description: 'شخص دارای کد ملی', icon: 'la-user'},
  {value: 2, label: 'حقوقی', description: 'شرکت یا سازمان دارای شناسه ملی', icon: 'la-building'},
  {value: 3, label: 'مشارکت مدنی', description: 'شراکت دارای شناسه مشارکت مدنی', icon: 'la-user-friends'},
  {
    value: 4,
    label: 'اتباع غیر ایرانی',
    description: 'دارای کد فراگیر یا شماره گذرنامه',
    icon: 'la-user-tie',
  },
]

/**
 * The first step of «افزودن خریدار» (507): four clear choices, each a button that opens the form for that type,
 * instead of dashed boxes that looked like file drop zones.
 */
const CustomerEditType: FC<props> = ({type}) => {
  return (
    <section aria-labelledby='mp-buyer-type-heading'>
      <h3 id='mp-buyer-type-heading' className='fs-5 fw-bold text-gray-800 mb-4'>
        نوع خریدار را انتخاب کنید
      </h3>
      <div className='mp-catalog-choice-tiles'>
        {buyerTypes.map((item) => (
          <button
            key={item.value}
            type='button'
            className='mp-catalog-choice-tile'
            onClick={() => type.setType(item.value)}
          >
            <span className='mp-catalog-choice-tile__icon' aria-hidden='true'>
              <i className={clsx('las', item.icon)}></i>
            </span>
            <span className='mp-catalog-choice-tile__text'>
              <span className='mp-catalog-choice-tile__label'>{item.label}</span>
              <span className='mp-catalog-choice-tile__description'>{item.description}</span>
            </span>
            <i className='las la-angle-left mp-catalog-choice-tile__chevron' aria-hidden='true'></i>
          </button>
        ))}
      </div>
    </section>
  )
}

export {CustomerEditType}
